<template>
    <div>
        <div class="form-group">
            <label class="col-md-2 control-label">Land Ownership</label>
            <div class="col-md-8">
                <v-client-table :data="landOwnershipList" :columns="landOwnershipTable.columns" :options="landOwnershipTable.options">
                    <template slot="delete" slot-scope="props" v-if="!formDisabled">
                        <div style="text-align: center;">
                            <a class="fa fa-ban" style="font-size: 18px;" v-on:click="deleteLandOwnership(props.row.landOwnershipId)"></a>
                        </div>
                    </template>
                </v-client-table>
            </div>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-2">
            <button name="add" class="btn btn-primary" :disabled="!parentId" v-show="!formDisabled" v-on:click.prevent="$refs['landOwnershipModal'].open()">Add Land Ownership</button>
        </div>
        <div class="col-md-2" v-if="!formDisabled">
            <modal title="Add Land Ownership" ref="landOwnershipModal">
                <div slot="header">
                    <h4>Add Land Ownership</h4>
                </div>
                <div slot="body">
                    <form class="form" id="landOwnershipForm" data-vv-scope="landOwnershipForm">
                        <div class="form-group">
                            <label class="col-md-2 control-label">Landowner</label>
                            <div class="col-md-4">
                                <select class="form-control" v-model="landOwnershipDto.landownerTypeId" v-on:change="landownerTypeChange">
                                    <option value="" disabled>Select a value</option>
                                    <option v-for="owner in landownerTypeList" v-bind:value="owner.id" :key="owner.id">
                                        {{ owner.description}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <!-- <div class="form-group" v-if="[7].includes(landOwnershipDto.landownerTypeId)" v-bind:class="{ 'has-error': errors.has('landOwnershipForm.landManager') }">
                            <label class="col-md-2 control-label">Landowner Other</label>
                            <div class="col-md-4">
                                <input class="form-control" v-model.number="landOwnershipDto.landownerOther">
                            </div>
                        </div> -->
                        <div class="form-group" v-if="[1,2].includes(landOwnershipDto.landownerTypeId)" v-bind:class="{ 'has-error': errors.has('landOwnershipForm.landManager') }">
                            <label class="col-md-2 control-label">Land Manager</label>
                            <div class="col-md-4">
                                <select name="landManager" class="form-control" v-model="landOwnershipDto.landManagerTypeId" v-validate="'required'">
                                    <option :value='null' disabled>Select a value</option>
                                    <option v-for="manager in landManagerTypeListFiltered" v-bind:value="manager.landManagerTypeId" :key="manager.landManagerTypeId">
                                        {{ manager.description}}
                                    </option>
                                </select>
                                <div><span v-show="errors.has('landOwnershipForm.landManager')" class="has-error">Land manager is required</span></div>
                            </div>
                        </div>
                        <div class="form-group" v-if="isInvestigation">
                            <label class="col-md-2 control-label">Survey Type</label>
                            <div class="col-md-4">
                                <select class="form-control" v-model="landOwnershipDto.landTypeId">
                                    <option value="" disabled>Select a value</option>
                                    <option v-for="land in landTypeList" v-bind:value="land.id" :key="land.id">
                                        {{ land.description}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group" v-if="isInvestigation">
                            <label class="col-md-2 control-label">Acres</label>
                            <div class="col-md-4">
                                <input class="form-control" type="number" min="0" step=".1" v-model.number="landOwnershipDto.acres">
                            </div>
                        </div>
                        <div class="form-group" v-if="isInvestigation">
                            <label class="col-md-2 control-label">Corridor</label>
                            <div class="col-md-4">
                                <input class="form-control" type="number" min="0" step=".1" v-model.number="landOwnershipDto.corridor">
                            </div>
                        </div>
                        <div class="form-group" v-if="isInvestigation">
                            <label class="col-md-2 control-label">Corridor Units</label>
                            <div class="col-md-4">
                                <input type="radio" id="corridorFeet" value=true v-model="landOwnershipDto.corridorIsFeet">
                                <label for="corridorFeet">Feet</label><br>
                                <input type="radio" id="corridorOther" value=false v-model="landOwnershipDto.corridorIsFeet">
                                <label for="corridorOther">Other: </label>
                                <input class="form-control" type="text" v-model="landOwnershipDto.corridorOther">
                            </div>
                        </div>
                    </form>
                </div>
                <div slot="footer">
                    <div>
                        <button class="btn btn-primary col-md-3" v-on:click.prevent="saveLandOwnership()" :disabled="isLoading">Save</button>
                        <button class="btn btn-primary col-md-3" v-on:click.prevent="$refs['landOwnershipModal'].close()">Close</button>
                    </div>
                </div>
            </modal>
        </div>
        <div v-if="isDebug">
            <div>
                <h3 class="text-danger">****** Debug ******</h3>
            </div>
            <div>
                <ul>
                    <li>Props: { parentId: {{parentId}}, source: {{source}}, formDisabled: {{formDisabled}} }</li>
                    <li>landOwnershipList: {{landOwnershipList}}</li>
                    <li>landOwnershipDto: {{landOwnershipDto}}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<style>
</style>

<script>
import loggingService from '@/services/util/loggingService'
import landOwnershipService from '../services/landOwnershipService'

import modal from '@/components/Modal.vue'

export default {
    components: {
        modal: modal
    },
    name: 'landOwnership',
    data: function () {
        return {
            isDebug: false,
            isLoading: true,
            landTypeList: landOwnershipService.LandTypeList,
            landownerTypeList: landOwnershipService.LandownerTypeList,
            landManagerTypeList: [],
            landOwnershipList: [],
            landOwnershipDto: {
                landOwnershipId: 0,
                parentId: this.parentId,
                landManagerTypeId: null,
                landownerTypeId: null,
                landTypeId: null,
                acres: null,
                corridor: null,
                corridorIsFeet: true,
                corridorOther: ''
            }
        }
    },
    props: {
        parentId: { default: null },
        source: { default: null },
        formDisabled: { default: false }
    },
    computed: {
        isInvestigation: function () {
            return this.source === 'Investigation' || this.source === 'FieldworkRequest'
        },
        landOwnershipTable: function () {
            var columnList = ['landownerText', 'landManagerText']
            if (this.isInvestigation) {
                columnList.push('landText')
                columnList.push('acres')
                columnList.push('corridorText')
            }
            if (!this.formDisabled) {
                columnList.push('delete')
            }
            return {
                columns: columnList,
                options: {
                    headings: {
                        landManagerText: 'Land Manager',
                        landownerText: 'Landowner',
                        landText: 'Land Type',
                        acres: 'Acres',
                        corridorText: 'Corridor',
                        delete: 'Delete'
                    },
                    filterable: false
                }
            }
        },
        landManagerTypeListFiltered: function () {
            return this.landManagerTypeList.filter(x => x.landownerTypeId === null || x.landownerTypeId === this.landOwnershipDto.landownerTypeId)
        }
    },
    watch: {
        parentId: function () {
            this.landOwnershipDto.parentId = this.parentId
            this.loadData()
        }
    },
    created () {
        loggingService.log(this.isDebug, 'landOwnership', 'created')
    },
    mounted () {
        loggingService.log(this.isDebug, 'landOwnership', 'mounted')
        this.loadLandManagerTypes()
        this.loadData()
        this.isLoading = false
    },
    methods: {
        loadLandManagerTypes () {
            return landOwnershipService.listLandManagerTypes(this.$http).then(response => {
                this.landManagerTypeList = response.data
                loggingService.log(this.isDebug, 'Investigation', 'loaded land manager list')
                return response
            })
        },
        loadData () {
            if (this.parentId && this.source) {
                loggingService.log(this.isDebug, 'landOwnership', 'loading data, parentId: ' + this.parentId)
                var handle = this
                landOwnershipService.listLandOwnership(this.$http, this.source, this.parentId).then(function (response) {
                    if (response.data) {
                        handle.landOwnershipList = response.data
                    }
                })
            }
        },
        saveLandOwnership () {
            this.$validator.validateAll('landOwnershipForm').then(result => {
                if (result && this.landOwnershipDto.parentId && this.source) {
                    loggingService.log(this.isDebug, 'landOwnership', 'save')
                    this.isLoading = true
                    var handle = this
                    landOwnershipService.saveLandOwnership(this.$http, this.source, this.landOwnershipDto).then(response => {
                        handle.loadData()
                        handle.isLoading = false
                        handle.$refs['landOwnershipModal'].close()
                        handle.landOwnershipDto = {
                            landOwnershipId: 0,
                            parentId: handle.parentId,
                            landManagerTypeId: null,
                            landownerTypeId: null,
                            landTypeId: null,
                            acres: null,
                            corridor: null,
                            corridorIsFeet: true,
                            corridorOther: ''
                        }
                        this.errors.clear('landOwnershipForm')
                    })
                }
            })
        },
        deleteLandOwnership (id) {
            loggingService.log(this.isDebug, 'landOwnership', 'deleting landOwnershipId: ' + id)
            landOwnershipService.remove(this.$http, id).then(response => {
                this.loadData()
            })
        },
        landownerTypeChange () {

        }
    },
    destroyed () {
        loggingService.log(this.isDebug, 'landOwnership', 'destroyed')
    }
}

</script>



// WEBPACK FOOTER //
// LandOwnership.vue?6b4ee051